import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { PvsVertical } from 'models/interfaces/index';

const LIST_PVS_CAMPAIGN_VERTICAL = gql`
  query ListPvsVerticals {
    verticals: pvsVerticals {
      vertical_id
      ad_server_id
      ad_server_vertical_id
      ad_server_name
      display_name
      is_active
      last_sync_date
      is_dirty
      created_date
    }
  }
`;

interface PvsVerticalListContainerRenderProps {
  verticals: PvsVertical[];
}

interface PvsVerticalListContainerProps {
  children: (props: PvsVerticalListContainerRenderProps) => any;
}

const PvsVerticalListContainer: React.FunctionComponent<PvsVerticalListContainerProps> = ({
  children,
  ...props
}) => (
  <Query<PvsVerticalListContainerRenderProps> query={LIST_PVS_CAMPAIGN_VERTICAL}>
    {({ data: { verticals } = { verticals: [] as PvsVertical[] }, loading }) => {
      if (loading) {
        return null;
      }
      return (
        children &&
        children({
          ...props,
          verticals
        })
      );
    }}
  </Query>
);

export default PvsVerticalListContainer;
